import logo from './logo.svg';
import './Shared/Style/CSS/App.min.css';
import Modal from './Modal/Components/Modal';
import CounterApp from './Counter-App/Components/CounterApp';

function App() {
  return (
    <>
      <section className="App">
        <header className="App-header">
          <img src={logo} className="App-logo" alt="logo" />
          <p>Native ReactJS With Bootstrap Mini Projects<br /><a className="App-link" href="https://emad-zedan.com" target="_blank">Emad Zedan</a>  Copyright &copy; 2025</p>
        </header>
      </section>
      <section className="App">
        <Modal title="Test Bootstrap JS" body="Latest Bootstrap Javascript Is Working."></Modal>
      </section>
      <section className="App">
        <CounterApp></CounterApp>
      </section>
    </>
  );
}

export default App;
